<template>
  <b-modal no-close-on-backdrop ref="my-modal" size="xl" hide-footer title="Agregar Prácticas" v-on:hide="onModalHide()">

    <div class="lessons-model">
      <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar por titulo"
             aria-label="Search" aria-describedby="basic-addon2" v-model="searchPractices"  v-on:keyup="loadPractices()">
    </div>

    <div class="lessons-model">
      <table class="table">
        <thead>
        <tr>
          <th>Titulo</th>
          <th>Descripcción</th>
        </tr>
        </thead>
        <tbody v-for="(practice, index) in practicesItems" :key="index">
        <tr>
          <td>{{ practice.title }}</td>
          <td>{{ practice.text }}</td>
          <td><div class="col col-sm-6 col-md-6 col-lg-6 text-center">
            <b-button class="mt-3" v-on:click="savePractice(practice.id)"
                      block>Agregar</b-button>
          </div></td>
        </tr>
        </tbody>

        <tbody v-if="practicesItems &&  practicesItems.length === 0">
        <tr >
          <td colspan="2" class="td-nhd">No hay datos</td>
        </tr>
        </tbody>
      </table>
    </div>

  </b-modal>
  <!-- /add practices-->
</template>

<script>
import axios from "axios";

export default {
  props: {
    parentModel: String,
    lessonType: String,
    lessonId: String,
  },

  data() {
    return {
      practicesItems: [],
      searchPractices: "",
      isLoading: false,
    }
  },
  methods: {
    limitText (count) {
      return `and ${count} other countries`
    },
    savePractice(practiceId) {
      this.$emit('savePractice', { questionId: practiceId, type: this.lessonType });
    },
    loadPractices() {
      axios
        .get(import.meta.env.VITE_API_BASE_URL + "/api/practices/getPracticesListforAdd/" + this.lessonId, {
          params: {
            search: this.searchPractices,
            modelName: "lessons"
          },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          if (response.data) {
            response.data;
          }
          this.practicesItems = response.data;

        })
        .catch((err) => {
          console.log(err.message);;
        });
    },
    onModalHide() {
      this.practicesItems= '';
    },
    showModal() {
      this.$refs['my-modal'].show();
    }
  }
}
</script>

<style scoped>

</style>
